/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

export default {
  xAxisKey: {
    arrivalTime: 'arrival_time',
    forecastTs: 'forecast_ts',
  },
  aloftBoundBox: {
    leftLongitude: -126,
    rightLongitude: -66,
    topLatitude: 50,
    bottomLatitude: 24,
  },
  bknMetar: 'BKN',
  ovcMetar: 'OVC',
  clrMetar: 'CLR',
  skcMetar: 'SKC',
  ovxMetar: 'OVX',
  Obscured: 'Obscured',
  defaultMaxAltAllowed: 12000,
  cloudPriorityMetar: ['OVC', 'BKN', 'SCT', 'FEW', 'CLR'],
  airportActions: [{
    key: 'metars',
    text: 'METARs',
  }, {
    key: 'tafs',
    text: 'TAF',
  }, {
    key: 'mav',
    text: 'MAV',
  }, {
    key: 'met',
    text: 'MET',
  }, {
    key: 'lamp',
    text: 'LAMP',
  }, {
    key: 'meteogram',
    text: 'Meteogram',
  }, {
    key: 'surfaceanalysis',
    text: 'Surface Analysis',
  }, {
    key: 'afd',
    text: 'AFD',
  }, {
    key: 'nammos (met)',
    text: 'NAM MOS (MET)',
  }, {
    key: 'gfsmos (mav)',
    text: 'GFS MOS (MAV)',
  }, {
    key: 'fcstdiscussion',
    text: 'Fcst Discussion',
  }, {
    key: 'nexrad',
    text: 'NEXRAD',
  }, {
    key: 'skew-t',
    text: 'Skew-T',
  }, {
    key: 'radar',
    text: 'Radar',
  }, {
    key: 'moshelp',
    text: 'MOS Help',
  }],
  metarToBnMapping: {
    CLR: 'CL',
    FEW: 'FW',
    SCT: 'SC',
    BKN: 'BK',
    OVC: 'OV',
  },
  clouds: {
    clear: 'CL',
    few: 'FW',
    scattered: 'SC',
    partial: 'PC',
    broken: 'BK',
    overcast: 'OV',
    ovx: 'OVX',
  },
  timeOfDay: {
    day: 'day',
    night: 'night',
  },
  aloftCloudIndexMap: [
    // This will be by default used till the time aloft data is not avaialble
    100,
    985.8,
    1712.4,
    2459.5,
    3224.9,
    4810.6,
    6468.0,
    8204.5,
    10038.9,
    11993.7,
    14077.6,
    16302.1,
    18686.4,
    21262.8,
    24073.5,
    27172.7,
    30643.1,
    34594.5,
    39219.9,
    45000,
  ],
  rulesetColorMappingRruleset: ['magenta', 'red', '#3366FF', 'green'], // this is for meteogram and routeprofile dots
  rulesetLblMappingRruleset: ['LIFR', 'IFR', 'MVFR', 'VFR'], // this is for meteogram and routeprofile dots
  aloftCloudIndexMapKey: 'aloftCloudIndexMapKey',
  aloftAltitudeMap: [], // I think we can remove this. Will check
  // This will be populated in utilityService.loadAloftAltitudeMap aloftAltitudeMapRoute
  aloftAltitudeMapRoute: [],
  // This will be populated in utilityService.loadAloftAltitudeMap aloftAltitudeMapMeteo
  aloftAltitudeMapMeteo: [],
  // altitudeOptions is deprecated refer altitude constant file
  altitudeOptions: [6000, 12000, 20000, 45000, 28000],
  altServiceOptions: {
    6000: 6,
    12000: 10,
    20000: 13,
    28000: 16,
    45000: 21,
  },
  rulesetColorMapping: ['magenta', 'red', '#3366FF', 'green'],
  rulesetLblMapping: ['LIFR', 'IFR', 'MVFR', 'VFR'],
  factoryRuleSetMap: {
    r: {
      clr: ['green', '#3366FF', '#FFF779', 'red', '#FF6699'],
      lbl: ['VFR', 'MVFR', 'IFR', 'LIFR', 'VLIFR'],
      vis: ['low', 6, 5, 4, 2, 1],
      cig: ['low', 6, 5, 3, 2, 1],
    },
    c: {
      clr: ['green', '#3366FF', '#FFF779', 'red', '#FF6699'],
      lbl: ['VFR', 'MVFR', 'IFR', 'LIFR', 'VLIFR'],
      cig: ['low', 6, 5, 3, 2, 1],
    },
    z: {
      clr: ['green', '#3366FF', '#FFF779', 'red', '#FF6699'],
      lbl: ['VFR', 'MVFR', 'IFR', 'LIFR', 'VLIFR'],
      vis: ['low', 6, 5, 4, 2, 1],
    },
    w: {
      clr: ['green', '#FFF779', '#FF9900', 'red'],
      lbl: ['low', 'medium', 'high', 'extreme'],
      xwd: ['high', 0, 7, 10, 17],
      xwg: ['high', 0, 7, 10, 17],
      wsp: ['high', 0, 15, 20, 30],
      wsg: ['high', 0, 15, 20, 30],
      gsp: ['high', 0, 5, 10, 15],
    },
    p: {
      clr: ['green', '#FFF779', '#FF9900', 'red'],
      lbl: ['low', 'medium', 'high', 'extreme'],
      ppo: ['high', 20, 40, 60, 80],
      p06: ['high', 20, 40, 60, 80],
      t06: ['high', 10, 20, 30, 40],
      cp2: ['high', 20, 40, 60, 80],
      st6: ['high', 5, 10, 15, 20],
    },
    i: {
      clr: ['green', '#FFF779', '#FF9900', 'red'],
      lbl: ['I', 'II', 'III', 'IV'],
      vis: ['low', 5, 4, 3, 2],
      xwd: ['high', 0, 7, 10, 17],
      xwg: ['high', 0, 7, 10, 17],
      wsp: ['high', 0, 15, 20, 30],
      wsg: ['high', 0, 15, 20, 30],
      gsp: ['high', 0, 5, 10, 15],
      p06: ['high', 20, 40, 60, 80],
      t06: ['high', 10, 20, 30, 40],
      cp2: ['high', 20, 40, 60, 80],
      st6: ['high', 5, 10, 15, 20],
      cig: ['low', 5, 4, 3, 2],
      fzp: ['high', 5, 10, 15, 20],
      sno: ['high', 0, 10, 15, 20],
    },
    v: {
      clr: ['green', '#FFF779', '#FF9900', 'red'],
      lbl: ['I', 'II', 'III', 'IV'],
      vis: ['low', 7, 6, 5, 4],
      xwd: ['high', 0, 7, 10, 17],
      xwg: ['high', 0, 7, 10, 17],
      wsp: ['high', 0, 15, 20, 30],
      gsp: ['high', 0, 15, 20, 30],
      p06: ['high', 20, 40, 60, 80],
      t06: ['high', 10, 20, 30, 40],
      cp2: ['high', 20, 40, 60, 80],
      st6: ['high', 5, 10, 15, 20],
      cig: ['low', 6, 5, 4, 3],
      fzp: ['high', 5, 10, 15, 20],
      sno: ['high', 0, 10, 15, 20],
    },
  },
};
